// NarrativeBlock.jsx — Task 11 artifact slot. The plain-English block. Props: { title?, markdown }.
//
// ISOLATION CONTRACT (mandatory): model-authored report text is untrusted multi-tenant content, so it
// flows through the ONE audited AssistantMarkdown module (the shared constrained, NO-rehype-raw
// renderer). This file adds NO second markdown library — same rule as ReportArtifact.jsx.
import React from "react"
import AssistantMarkdown from "../../AssistantMarkdown.jsx"

export default function NarrativeBlock({ title, markdown, body }) {
  // Tolerate reasonable key variance: canonical is `markdown`, the live agent also uses `body`
  // (G-LIVE session 77 + design mock's SlotNarrative shape).
  const text = typeof markdown === "string" && markdown.trim() ? markdown : typeof body === "string" ? body : ""
  if (!text.trim()) return null
  return (
    <div className="afq-card afq-narr" data-slot="narrative_block">
      {title ? <div className="afq-narr-h">{title}</div> : null}
      <div className="afq-narr-body">
        <AssistantMarkdown text={text} />
      </div>
    </div>
  )
}
